import { jsx } from 'react/jsx-runtime';
import DeleteIcon from '../../../Icons/DeleteIcon.js';
import Button from '../../Button/Button.js';

/**
 * Bottone di chiusura di una modale.
 */
function CloseModalButton({ onClose }) {
    return (jsx(Button, { className: "v2-modal__close", onClick: onClose, children: jsx(DeleteIcon, {}) }));
}

export { CloseModalButton as default };
